import { useEffect } from "react";;

declare global {
    interface Window {
        adsbyimobile: any[];
    }
}
const ImobileBanner = () => {
    useEffect(() => {
        const initAd = () => {
            window.adsbyimobile = window.adsbyimobile || [];
            window.adsbyimobile.push({
                pid: 84631,
                mid: 591482,
                asid: 1925996,
                type: "banner",
                display: "inline",
                elementid: "im-7c5f4cb68c5946ceb0eeb852a325265b",
            });
        };

        if (!document.getElementById("imobile-script")) {
            const script = document.createElement("script");
            script.src = "https://imp-adedge.i-mobile.co.jp/script/v1/spot.js?20220104";
            script.async = true;
            script.id = "imobile-script";

            script.onload = initAd;

            document.body.appendChild(script);
        } else {
            initAd();
        }
    }, []);

    return (
        <div id="im-7c5f4cb68c5946ceb0eeb852a325265b"></div>
    );
};

export default ImobileBanner;